// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__QtgiR","title":"styles_title__8FCqv","description":"styles_description__rc_jC"};